import React from 'react';

import GlobalStyle from './styles';
import Header from './components/header';
import Footer from './components/footer';
import HomePage from './pages/home';

// import './styles/css/index.css';

function App() {
  return (
    <div className="App">
      <GlobalStyle />
      <Header />
      <main>
        <HomePage />
      </main>
      <Footer />
    </div>
  );
}

export default App;
